module.exports = __webpack_public_path__ + "img/user-guide-02-06-03.1305941d.png";